import Function from './Function'

export default Function
